module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/2-fdadf037a153767214c2527ea3928183.jpg";